// Font family for all text elements (must be explicit for SVG-to-PNG conversion)
export const CHART_FONT_FAMILY = "'Lato', sans-serif";

export const MARGIN = { left: 20, right: 20, top: 10, bottom: 4 };
export const Y_AXIS_WIDTH = 130;
export const X_AXIS_HEIGHT = 30;
export const RANGE_MARKER_HEIGHT = 10;
export const DOT_RADIUS = 5;
export const LEGEND_WIDTH = 180;
export const LEGEND_ITEM_SPACING = 95; // horizontal gap between legend items (right-anchored)
// Tooltip constants
export const TOOLTIP_PILL_HEIGHT = 24;
export const TOOLTIP_PILL_PADDING_X = 8;
export const TOOLTIP_FONT_SIZE = 11;
export const TOOLTIP_VERTICAL_OFFSET = 8;
export const TOOLTIP_OPACITY = 0.9;

// Hover area constants
export const HOVER_DOT_RADIUS_PADDING = 4;
export const HOVER_MARKER_WIDTH_HALF = 6;
export const HOVER_MARKER_WIDTH = 12;

// Text width approximation for tooltip sizing (pixels per character at font-size 11)
export const TOOLTIP_CHAR_WIDTH = 6.5;

export const PNG_WIDTH = 510;
export const PNG_HEIGHT = 88;

export const IMAGE_FACTOR = 1.5;
